import { Cookie } from "../helpers/cookie";
export default class PrivacyPolicy {
    constructor() {
        this.cookieName = "privacy-policy";
        this.element = document.querySelector(".privacy-policy");
        if (this.element)
            this.init();
    }
    init() {
        let cookie = Cookie.get(this.cookieName);
        let accepted = !String.isNullOrWhitespace(cookie);
        this.element.visible(!accepted);
        let close = this.element.querySelector(".close");
        close.addEventListener("click", () => {
            Cookie.set(this.cookieName, "accepted");
            this.element.visible(false);
        });
    }
}
